import _inject from "@stylexjs/stylex/lib/stylex-inject";
import React from "react";
import * as stylex from "@stylexjs/stylex";
export default function RowObj(props) {
  var classes = [];
  if (props.grid) {
    classes.push('grid');
  } else {
    classes = ['row', 'col', 'col-12'];
  }
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "RowObj__ui.base evd0eoby ev1csc8e1"
  }, props.row));
}
_inject(".evd0eoby{border-bottom:1px solid var(--shade-05)}", 2000);
_inject(".ev1csc8e1:last-of-type{border-bottom:0 solid red}", 2055);